import { CommonModule } from "@angular/common";
import { Component, Inject, OnInit, TemplateRef } from "@angular/core";
import { MatButtonModule } from "@angular/material/button";
import { PatientDocumentClient } from "src/app/common/services/patient-document.client";
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogModule,
  MatDialogRef,
} from "@angular/material/dialog";
import { MatIconModule } from "@angular/material/icon";
import { firstValueFrom } from "rxjs";
import { PhysicianClient, PhysicianListItem } from "src/app/common/services/physician.client";
import { SessionExpiredComponent } from "src/app/features/login/session-expired/session-expired.component";
import { DropdownComponent } from "../../dropdown/dropdown.component";
import { DomSanitizer, SafeHtml } from "@angular/platform-browser";

@Component({
  selector: "app-confirmation-modal",
  templateUrl: "./confirmation-modal.component.html",
  styleUrls: ["./confirmation-modal.component.scss"],
  standalone: true,
  imports: [CommonModule, MatDialogModule, MatButtonModule, MatIconModule, DropdownComponent],
})
export class ConfirmationModalComponent implements OnInit {
  loaded!: boolean;
  title: string;
  message: SafeHtml;
  note: string;
  buttonText: string;
  hideContinueMessage: boolean;
  hideCancelButton: boolean;
  hideMainButton: boolean;
  isError!: boolean;
  leftAlign: boolean;
  cancelText: string;
  isAddPractitioner!: boolean;

  dropdownOptions: PhysicianListItem[] = [];
  defaultDropdownSelection: any;
  facilityId!: string;
  selectedOptionId!: number;
  facilityid!: string;

  contentTemplate: TemplateRef<any>;
  templateContext: any; 

  constructor(
    public dialog: MatDialogRef<ConfirmationModalComponent>,
    private dialogRef: MatDialog,
    public patientDocumentClient: PatientDocumentClient,
    private physicianClient: PhysicianClient,
    private sanitizer: DomSanitizer,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.title = data.title;
    this.message = this.sanitizer.bypassSecurityTrustHtml(data.message);
    this.buttonText = data.buttonText;
    this.note = data.note;
    this.hideContinueMessage = data.hideContinueMessage || false;
    this.hideCancelButton = data.hideCancelButton || false;
    this.isError = data.isError || false;
    this.leftAlign = data.leftAlign || false;
    this.cancelText = data.cancelText ? data.cancelText : "Cancel";
    this.hideMainButton = data.hideMainButton || false;
    this.isAddPractitioner = data.isAddPractitioner || false;
    this.facilityid = data.facilityid;
    this.contentTemplate = data.contentTemplate;
    this.templateContext = data.templateContext;
  }

  ngOnInit(): void {
    this.dialog.addPanelClass("custom-dialog-container");
    const isSessionExpiredDialogOpen = this.dialogRef.openDialogs.some(
      (dialogRef) =>
        dialogRef.componentInstance instanceof SessionExpiredComponent
    );
    if (isSessionExpiredDialogOpen) {
      this.dialog.close();
    }
    if(this.facilityid && this.isAddPractitioner) {
      this.getPhysicianClientList(this.facilityid)
    }
  }

  async action() {
    try {
      if (this.data.method) {
        await this.data.method();
      } else {
        this.dialog.close({practitionerId: this.selectedOptionId || this.defaultDropdownSelection});
        return;
      }

      if (!this.data.hideActionToast) {
      }

      this.dialog.close(true);
    } catch (err: any) {
      this.dialog.close(false);

      this.dialogRef.open(ConfirmationModalComponent, {
        data: {
          title: "Error",
          message: err?.error,
          buttonText: "OK",
          hideCancelButton: true,
          isError: true,
        },
      });
    }
  }

  async getPhysicianClientList(facilityId: string){
    this.dropdownOptions = (
      await firstValueFrom(
        this.physicianClient.getPhysiciansByFacilityId(
          facilityId,
        )
      )
    )?.data;
    this.patientDocumentClient.defaultPractionerId.subscribe(x => {
      const defaultPractionerId = x;
      if(defaultPractionerId != 0){
        this.defaultDropdownSelection = defaultPractionerId;
      }else{
        this.defaultDropdownSelection = this.dropdownOptions[0].id;
      }
    });
  }
  public dropDownValueChange(option: any) {
    this.selectedOptionId = option?.value;
  }
}
